import styled from 'styled-components';

import ControlContainer from '@ad-scripts/presentation/components/common/forms/control_container';

export default styled(ControlContainer)``;
